export default __webpack_public_path__ + "static/media/search.96bf8571.svg";